import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { ModalAction, SaleAction } from '../../store/actions';

class Certificate extends PureComponent {
  static propTypes = {
    getSale: PropTypes.func,
    openModal: PropTypes.func,
    permissions: PropTypes.arrayOf(PropTypes.string),
    sale: PropTypes.object,
    saleId: PropTypes.number,
  };

  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  componentDidMount() {
    this.props.getSale(this.props.saleId);
  }

  handlePrint() {
    const _window = window.open();
    _window.document.write(
      '<style>*{box-sizing:border-box;line-height:1.5;margin:0;padding:0;}</style>',
    );
    _window.document.write(this.ref.current.innerHTML);
  }

  render() {
    return (
      <div className="row">
        <div className="col-12">
          <button
            className="btn btn-primary btn-sm"
            onClick={this.handlePrint.bind(this)}
            type="button"
          >
            Print
          </button>
          {(this.props.permissions?.includes?.('sale.custom_edit') ||
            (this.props.permissions?.includes?.('sale.custom_edit_once') &&
              !this.props.sale?.custom_id &&
              !this.props.sale?.custom_price &&
              !this.props.sale?.custom_sold_at)) && (
            <button
              className="btn btn-info btn-sm ml-1"
              onClick={() => this.props.openModal(this.props.sale)}
              type="button"
            >
              Custom Edit
            </button>
          )}
        </div>
        <div className="col-12">
          <div
            ref={this.ref}
            style={{
              height: 59 * 0.5 + 'cm',
              width: 42 * 0.5 + 'cm',
            }}
          >
            <div
              style={{
                display: 'flex',
                height: 14 * 0.5 + 'cm',
                paddingLeft: 6 * 0.5 + 'cm',
                paddingTop: 8.5 * 0.5 + 'cm',
                textTransform: 'uppercase',
                width: 42 * 0.5 + 'cm',
              }}
            >
              <p
                style={{
                  marginBottom: 0,
                  width: 28 * 0.5 + 'cm',
                }}
              >
                {this.props.sale?.custom_id}-
                {this.props.sale?.customer?.mobile_number}
              </p>
              <p
                style={{
                  marginBottom: 0,
                }}
              >
                {this.props.sale?.custom_sold_at}
              </p>
            </div>
            <div
              style={{
                height: 5 * 0.5 + 'cm',
                paddingLeft: 2 * 0.5 + 'cm',
                textTransform: 'uppercase',
                width: 42 * 0.5 + 'cm',
              }}
            >
              <p
                style={{
                  marginBottom: 0,
                }}
              >
                <span>{this.props.sale?.customer?.name}</span>
                <span
                  style={{
                    paddingLeft: 2 * 0.5 + 'cm',
                  }}
                >
                  {this.props.sale?.customer?.gender === 'female' ? 'D/O': 'S/O'}:
                  {' '}
                  {this.props.sale?.customer?.father_name}
                </span>
              </p>
              <p
                style={{
                  marginBottom: 0,
                  paddingTop: 0.5 * 0.5 + 'cm',
                }}
              >
                {this.props.sale?.customer?.address}
              </p>
            </div>
            <div
              style={{
                height: 29 * 0.5 + 'cm',
                paddingLeft: 18 * 0.5 + 'cm',
                paddingTop: 1 * 0.5 + 'cm',
                textTransform: 'uppercase',
                width: 42 * 0.5 + 'cm',
              }}
            >
              <p
                style={{
                  marginBottom: 0,
                  paddingTop: 0.57 * 0.5 + 'cm',
                }}
              >
                {this.props.sale?.purchase?.vehicle?.model}
              </p>
              <p
                style={{
                  marginBottom: 0,
                  paddingTop: 0.57 * 0.5 + 'cm',
                }}
              >
                {this.props.sale?.purchase?.vehicle?.class}
              </p>
              <p
                style={{
                  marginBottom: 0,
                  paddingTop: 0.57 * 0.5 + 'cm',
                }}
              >
                {this.props.sale?.purchase?.chassis_number}
              </p>
              <p
                style={{
                  marginBottom: 0,
                  paddingTop: 0.57 * 0.5 + 'cm',
                }}
              >
                {this.props.sale?.purchase?.engine_number}
              </p>
              <p
                style={{
                  marginBottom: 0,
                  paddingTop: 0.57 * 0.5 + 'cm',
                }}
              >
                {this.props.sale?.purchase?.vehicle?.cylinder_cc}
              </p>
              <p
                style={{
                  marginBottom: 0,
                  paddingTop: 0.57 * 0.5 + 'cm',
                }}
              >
                {this.props.sale?.purchase?.color?.name}
              </p>
              <p
                style={{
                  marginBottom: 0,
                  paddingTop: 0.57 * 0.5 + 'cm',
                }}
              >
                {this.props.sale?.purchase?.vehicle?.tyre_size}
              </p>
              <p
                style={{
                  marginBottom: 0,
                  paddingTop: 0.57 * 0.5 + 'cm',
                }}
              >
                {this.props.sale?.purchase?.vehicle?.manufacture_year}
              </p>
              <p
                style={{
                  marginBottom: 0,
                  paddingTop: 0.57 * 0.5 + 'cm',
                }}
              >
                {this.props.sale?.purchase?.vehicle?.horse_power}
              </p>
              <p
                style={{
                  marginBottom: 0,
                  paddingTop: 0.57 * 0.5 + 'cm',
                }}
              >
                {this.props.sale?.purchase?.vehicle?.laden_weight}
              </p>
              <p
                style={{
                  marginBottom: 0,
                  paddingTop: 0.57 * 0.5 + 'cm',
                }}
              >
                {this.props.sale?.purchase?.vehicle?.wheel_base}
              </p>
              <p
                style={{
                  marginBottom: 0,
                  paddingTop: 0.57 * 0.5 + 'cm',
                }}
              >
                {this.props.sale?.purchase?.vehicle?.seating_capacity}
              </p>
              <p
                style={{
                  marginBottom: 0,
                  paddingTop: 0.57 * 0.5 + 'cm',
                }}
              >
                {this.props.sale?.purchase?.vehicle?.maker_name}
              </p>
              <p
                style={{
                  marginBottom: 0,
                  paddingTop: 0.57 * 0.5 + 'cm',
                }}
              >
                {this.props.sale?.custom_price}
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => ({
  permissions: state?.auth?.permissions,
  sale: state?.sale?.detail,
  saleId: Number(props?.match?.params?.id),
});

const mapDispatchToProps = dispatch => ({
  getSale: id => dispatch(SaleAction.getSale(id)),
  openModal: data =>
    dispatch(ModalAction.openModal({ data, name: 'EditCustomSale' })),
});

export default connect(mapStateToProps, mapDispatchToProps)(Certificate);
